import { workflowDefaultPermissions } from "../Constants/workflowDefaultPermissions";
import { WorkflowDefaultPermission } from "../Models/WorkflowDefaultPermission";

interface IWorkflowDefaultPermissionsService {
  getDefaultAssignedRoles(
    permission: string,
    availableRoles: string[]
  ): WorkflowDefaultPermission[];
}

class WorkflowDefaultPermissionsService implements IWorkflowDefaultPermissionsService {
  getDefaultAssignedRoles(
    permission: string,
    availableRoles: string[]
  ): WorkflowDefaultPermission[] {
    if (!(permission in workflowDefaultPermissions)) {
      // no default permissions are configured
      return [];
    }

    const thisDefaultAssignedRoleSet = workflowDefaultPermissions[permission];

    return availableRoles.map((el: string) => {
      return {
        name: el,
        value: thisDefaultAssignedRoleSet.indexOf(el) > -1
      };
    });
  }
}

export const workflowDefaultPermissionsService: IWorkflowDefaultPermissionsService = new WorkflowDefaultPermissionsService();
